import React, {useEffect, useState} from 'react';
import {
   StyleSheet,
   View,
   Platform,
   Keyboard,
   TouchableWithoutFeedback,
   KeyboardAvoidingView,
} from 'react-native';

import NorcatLoginCard from '../login/LoginCard';
import {appBackgroundWhiteBG, isWindows} from '../../utils/utils';
import LoginHeader from '../login/LoginHeader';
import {CopyRightForTab} from '../../utils/CopyRightForTab';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';
import Orientation from 'react-native-orientation-locker';
import {useIsFocused} from '@react-navigation/native';

const LoginScreen = () => {
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [isKeyboardVisible, setKeyboardVisible] = useState(false);
   var marginSpace = 20;
   const isScreenFocused = useIsFocused();

   const bottomTabHeight = 64;
   const dismissKeyboard = () => {
      if (Platform.OS !== 'web') {
         Keyboard.dismiss();
      }
   };

   useEffect(() => {
      if ((isWindows && isScreenFocused) || !isWindows) {
         if (isLandscapeMode) {
            Orientation.lockToLandscape();
         } else {
            Orientation.lockToPortrait();
         }

         const keyboardWillShowListener = Keyboard.addListener(
            Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow',
            () => {
               setKeyboardVisible(true);
            },
         );

         const keyboardDidHideListener = Keyboard.addListener(
            'keyboardDidHide',
            () => {
               setKeyboardVisible(false);
            },
         );
         return () => {
            keyboardWillShowListener.remove();
            keyboardDidHideListener.remove();
         };
      }
   }, [isLandscapeMode]);

   return Platform.OS !== 'web' || !isLandscapeMode ? (
      <TouchableWithoutFeedback onPress={dismissKeyboard}>
         <KeyboardAvoidingView
            style={{
               flex: 1,
               ...Platform.select({
                  web: {
                     minHeight: '100vh',
                  },
               }),
            }}
            behavior={Platform.OS === 'ios' ? 'padding' : 'height'}>
            <View style={{flex: 1, backgroundColor: appBackgroundWhiteBG}}>
               <View style={{flex: 1}}>
                  <View
                     style={{
                        flex: 1,
                        flexDirection: !isLandscapeMode
                           ? 'column'
                           : 'row-reverse',
                     }}>
                     <View
                        style={{
                           flex: isLandscapeMode ? 1 : 5,
                           marginTop: !isLandscapeMode ? 0 : marginSpace,
                           marginRight: !isLandscapeMode ? 0 : marginSpace,
                           marginBottom: !isLandscapeMode
                              ? 0
                              : marginSpace + bottomTabHeight,
                        }}>
                        <LoginHeader isLandscapeMode={isLandscapeMode} />
                     </View>
                     <View
                        style={{
                           flex: isLandscapeMode ? 1 : 16,
                           justifyContent: 'flex-start',
                        }}>
                        <NorcatLoginCard
                           isPortrait={!isLandscapeMode}
                           isCopyrightShown={!isKeyboardVisible}
                        />
                     </View>
                  </View>
                  <CopyRightForTab
                     isPortrait={!isLandscapeMode}
                     isCopyrightShown={!isKeyboardVisible}
                  />
               </View>
            </View>
         </KeyboardAvoidingView>
      </TouchableWithoutFeedback>
   ) : (
      <View>
         <View style={styles.container}>
            <View
               style={{
                  flex: isLandscapeMode ? 1 : 16,
                  justifyContent: 'flex-start',
               }}>
               <NorcatLoginCard
                  isPortrait={!isLandscapeMode}
                  isCopyrightShown={!isKeyboardVisible}
               />
            </View>
            <View
               style={{
                  flex: isLandscapeMode ? 1 : 5,
                  marginTop: !isLandscapeMode ? 0 : marginSpace,
                  marginRight: !isLandscapeMode ? 0 : marginSpace,
                  marginBottom: !isLandscapeMode
                     ? 0
                     : marginSpace + bottomTabHeight,
               }}>
               <LoginHeader isLandscapeMode={isLandscapeMode} />
            </View>
         </View>
         <CopyRightForTab
            isPortrait={!isLandscapeMode}
            isCopyrightShown={!isKeyboardVisible}
         />
      </View>
   );
};

const styles = StyleSheet.create({
   container: {
      flex: 1,
      ...Platform.select({
         default: {
            flex: -1,
            height: '100vh',
            flexDirection: 'row',
         },
      }),
      backgroundColor: appBackgroundWhiteBG,
   },
   sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
   },
   sectionTitle: {
      fontSize: 24,
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '600' : 600,
   },
   sectionDescription: {
      marginTop: 8,
      fontSize: 18,
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '400' : 400,
   },
   highlight: {
      fontWeight:
         Platform.OS === 'ios' || Platform.OS === 'macos' ? '700' : 700,
   },
});

export default LoginScreen;
